import axios from "utils/APIv2";
export const updateUser = async (userID, values) => {
  return await axios.put(`/users/${userID}`, values);
};

export const getUser = async (userID) => {
  const res = await axios.get(`/users/${userID}`);
  return res.data;
};

export const getUsers = async (page, filterData) => {
  const params = {
    departments: "true",
    page: page,
    limit: "10",
    name: filterData.username,
    status: filterData.statusArray,
    role: filterData.roleArray,
    business: filterData.businessArray,
    sortOrder: filterData.sortOrder,
    sortOn: filterData.sortOn,
  };
  const res = await axios.get(`/users`, { params: params });
  return res.data;
};

export const addUser = async (User) => {
  return await axios.post(`/users`, User);
};
export const importCSV = (file) => {
  return axios.post(`/users/import`, file);
};
export const downloadSampleImportFile = () => {
  return `https://simplicapital-p2-bucket.s3.amazonaws.com/user_import_sample.csv`;
};

export const getUserIntegrations = async () => {
  return await axios.get("/integrations");
};

export const getCustomerDetailsforSingup = async (data) => {
  return await axios.post("/findCustomer", data);
};

export const updateMfa = async (body) => {
  return await axios.post("/updateMfa", body);
};
export const getAuthVerificationMethod = async()=>{
  return await axios.get('/register/auth-config')
}
export const getVerificationMethod = async()=>{
  return await axios.get('/verfication-method')
}

// The listing endpoint is fixed at ten rows a page, which is fine for a table
// and useless for a picker. Asks for one large page instead of walking them.
export const getUsersForPicker = async () => {
  const res = await axios.get(`/users`, {
    params: { page: 0, limit: "500", sortOn: "givenName", sortOrder: "asc" },
  });
  return res.data;
};
